module.exports = __webpack_public_path__ + "assets/cera_pro_bold-webfont.cbe51414.woff2";